import { useNavigate } from "react-router-dom"
import { useState, useEffect, useContext } from "react"
import { AuthContext } from "../contexts/AuthProvider";

import { db } from "../firebase/firebase";
import { collection, getDocs, query, where, doc, getDoc } from "firebase/firestore";

import "../styling/Subtopic.css"

export default function Subtopic({ topic, subtopic, progress }) {
    const { user } = useContext(AuthContext);
    const [questions, setQuestions] = useState([]);

    console.log("In subtopic: ", user);

    const navigate = useNavigate();

    const handleClick = async () => {
        await fetchQuestions(subtopic);
    }

    const [index, setIndex] = useState();

    const fetchInitialIndex = async() => {
        const indexRef = doc(db, "user_progress", user.uid)

        const snapshot = await getDoc(indexRef)

        const fetchedIndex = snapshot.data()[topic][subtopic].amountCompleted

        setIndex(fetchedIndex)
    }

    useEffect(() => {
        fetchInitialIndex();
        if (index >= questions.length || questions.length <= 0) {
            console.log("No more questions");
        } else {
            navigate(`/topic/${topic}/subtopic/${subtopic}/question/${index}`, {
                state: { questions },
            });
        };
        
    }, [questions])


    const fetchQuestions = async (subtopic) => {
        try {
            const questionsRef = collection(db, "questions"); 
            const q = query(questionsRef, where("subtopic", "==", subtopic));
    
            const querySnapshot = await getDocs(q);
    
            const questions = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
    
            setQuestions(questions);
        } catch (error) {
            console.error("Error fetching questions: ", error);
        }
    };

    const capitalizeSubtopic = (subtopic) => {
        return subtopic
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "); 
      };

    return (
        <div className="subtopic" onClick={handleClick}>
            <div className="subtopic__header">
                <h2 className="subtopic__header__text">{capitalizeSubtopic(subtopic)}</h2>
                <h2 className="subtopic__header__progress">({progress} / {20})</h2>
            </div>
            <div className="subtopic__progress-bar">
                <div className="subtopic__progress-bar-fill" style={{ width: `${( progress / 20) * 100}%`}}></div>
            </div>  
        </div>
    )
}